// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCjc-qR4MXWTxtrXMefCCUxlcMlzMixbzY",
  authDomain: "flowstate-c9247.firebaseapp.com",
  projectId: "flowstate-c9247",
  storageBucket: "flowstate-c9247.firebasestorage.app",
  messagingSenderId: "979301473725",
  appId: "1:979301473725:web:5652888385f3875ab446d4",
  measurementId: "G-JY914QHNBT",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth();
